import type { User } from "~/api/Api";

export function getUserFullName(user?: User | null): string {
  return `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim();
}
